import { useState, useEffect, useLayoutEffect } from "react"
import { motion, useIsPresent } from "framer-motion"
import { useLocation, useNavigate } from "react-router-dom"
import useWindowsWidth from "../hooks/useWindowsWidth"
import useGlobalContext from "../context/GlobalContext"
import { useLocomotiveScroll } from "react-locomotive-scroll"
import Footer from "../components/Footer"

export const title = {
  open: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
    },
  },
  closed: {
    opacity: 0,
  },
}

export const titleLetter = {
  open: {
    y: 0,
    opacity: 1,
  },
  closed: {
    y: 50,
    opacity: 0,
  },
}

const Work = () => {
  const { scroll } = useLocomotiveScroll()
  const { changeCursor } = useGlobalContext()
  const [width] = useWindowsWidth()
  const location = useLocation()
  const navigate = useNavigate()
  const proj = location.state?.proj
  const from = location.state?.from || "/"

  const isPresent = useIsPresent()

  const [selectedIndex, setSelectedIndex] = useState(0)

  useLayoutEffect(() => {
    window.scroll({ top: 0, behavior: "instant" })
  }, [])

  useEffect(() => {
    if (!proj) navigate("/")
  }, [navigate, proj])

  if (!proj) {
    return
  }

  return (
    <>
      <motion.div
        initial={{ scaleY: 2 }}
        animate={{ scaleY: 0, transition: { duration: 0.5, ease: "circOut" } }}
        exit={{ scaleY: 2, transition: { duration: 0.5, ease: "circIn" } }}
        style={{ originY: isPresent ? 0 : 1 }}
        className="privacy-screen"
      />
      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{
          opacity: 0,
        }}
        transition={{ duration: 0.5 }}
        onMouseEnter={() => changeCursor("")}
        className="work"
        data-scroll-section
      >
        <motion.button
          onClick={() => navigate(from)}
          onMouseEnter={() => changeCursor("btn-hover")}
          onMouseLeave={() => changeCursor("")}
          className="btn menu-btn work-btn uppercase pointer"
        >
          <span className="icon">&#8249;</span> Back
        </motion.button>
        <motion.div className="work-grid">
          <motion.picture className="selected-item">
            <img src={proj.gallery[selectedIndex].img} alt="" />
          </motion.picture>
          {width > 768 ? (
            <motion.aside
              className="gallery hide-scrollbar"
              onMouseEnter={() => scroll.stop()}
              onMouseLeave={() => scroll.start()}
            >
              {proj.gallery.map((item, i) => (
                <img
                  className={i === selectedIndex ? "selected" : ""}
                  key={item.id}
                  src={item.img}
                  loading="lazy"
                  decoding="async"
                  alt=""
                  onClick={() => setSelectedIndex(i)}
                />
              ))}
            </motion.aside>
          ) : null}
        </motion.div>
        <div className="proj-desc uppercase">
          <p className="par-md color-light">{proj.type}</p>
          <motion.h1
            variants={title}
            initial="closed"
            viewport={{ once: true }}
            whileInView="open"
            className="title proj-title"
          >
            {Array.from(proj?.title).map((l, i) => (
              <motion.span variants={titleLetter} key={i}>
                {l}
              </motion.span>
            ))}
          </motion.h1>
          <div className="pd-l gap-2">
            <p className="par">
              STARRING MAX BAISSETTE DE MALGLAIVE, REBECCA BENHAMOUR AND
              THIBAULT FARNOUX
            </p>
            <p className="par">
              PITCH: BENJAMIN EST PRÊT À TOUT POUR S'EXTRAIRE DE SA CONDITION,
              FAIRE PARTIE DES 13 ÉLUS ET PEUT ÊTRE GOUTER À LA RECONNAISSANCE
              ULTIME. YOU JUST WASTED YOUR TIME READING UNRELATED TEXT.
            </p>
          </div>
          {width <= 768 ? (
            <>
              <p className="par-md color-light">Gallery</p>
              <motion.aside className="pb-5 gallery hide-scrollbar mobile">
                {proj.gallery.map((item, i) => (
                  <img
                    key={item.id}
                    src={item.img}
                    loading="lazy"
                    decoding="async"
                    alt=""
                  />
                ))}
              </motion.aside>
            </>
          ) : null}
          <div className="flex-col">
            <h2 className="title-md uppercase f-normal">TECH SPECS</h2>
            <ul className="specs-list flex-col">
              {Object.keys(proj?.specs).map((key, index) => (
                <li
                  key={key}
                  className="specs-item flex space-between align-center"
                >
                  <span className="color-light">{key}</span>
                  <span>{proj?.specs[key]}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex-col pt-6">
            <h2 className="title-md uppercase f-normal">CREDITS</h2>
            <ul className="specs-list flex-col">
              {Object.keys(proj?.credits).map((key, index) => (
                <li
                  key={key}
                  className="specs-item flex space-between align-center"
                >
                  <span className="color-light">{key}</span>
                  <span>{proj?.credits[key]}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </motion.section>
      <Footer />
    </>
  )
}

export default Work
